import React, { useState } from 'react';
import { Alert, TextField, Button, Grid2, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { reportServices } from '../../services/reportServices';
import Clear from '@mui/icons-material/Clear';
import GetApp from '@mui/icons-material/GetApp';
import { downloadReport } from '../../utils/downloadReport ';
import '../../css/Reports.css';
import ReportGenerateButton from '../common/ReportGenerateButton';
import PageHeader from '../ui/PageHeader';

const MissedExDateReport = ({ showHeader = true }) => {

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const { t } = useTranslation();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState('');
    const [generating, setGenerating] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
    };

    const handleReport = () => {
        setGenerating(true);
        const formData = {
            startDate,
            endDate
        };
        if (startDate <= endDate) {
            reportServices.downloadMissedExpectedDateReport(formData)
                .then((response) => {

                    downloadReport(response);

                    setGenerating(false);
                    setSuccessMessage("Report Generated Successfully!");
                    setTimeout(() => setSuccessMessage(null), 4000);

                    setStartDate('');
                    setEndDate('');
                })
                .catch((error) => {
                    setError(error.message);
                    setTimeout(() => {
                        setError(null);
                    }, 4000);
                });
        } else {
            setError('Error! Start date must be earlier than end date.');
            setTimeout(() => {
                setError(null);
            }, 4000);
        }

    };

    return (
        <div className={showHeader ? "reports-container" : ""}>
            {showHeader && (
                <PageHeader title="Missed Expected Date Report" />
            )}
            <Box className={showHeader ? "report-box" : ""}>

                {successMessage && (
                    <Alert variant="filled" severity="success" style={{ marginBottom: '1.25rem' }}>
                        {successMessage}
                    </Alert>
                )}

                {error && (
                    <Alert variant="outlined" severity="error" style={{ marginBottom: '1.25rem' }}>
                        {error}
                    </Alert>
                )}

                <form style={{ marginTop: '1.25rem' }}>
                    <Grid2 container spacing={3}>

                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="date"
                                label={t('report.startDate')}
                                variant="outlined"
                                fullWidth
                                required
                                className='label-font'
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                margin="normal"
                                slotProps={{
                                    inputLabel: { shrink: true },
                                }}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="date"
                                label={t('report.endDate')}
                                variant="outlined"
                                fullWidth
                                required
                                className='label-font'
                                disabled={startDate ? false : true}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                margin="normal"
                                slotProps={{
                                    inputLabel: { shrink: true },
                                }}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }} className="gridContainer">
                            <ReportGenerateButton
                                onClick={handleReport}
                                loading={generating}
                                disabled={!(startDate && endDate) || (Boolean(loading) || generating)}
                                className={`commonButton ${(startDate && endDate) ? 'reportButtonSuccess' : 'reportButtonDefault'}`}
                                icon={<GetApp />}
                                label={t('job.report')}
                                loadingLabel="Preparing your report..."
                            />
                            <Button
                                type="button"
                                variant="contained"
                                onClick={handleClear}
                                className={`commonButton clearButton`}
                                disabled={(Boolean(loading) || generating)}
                            >
                                <Clear style={{ marginRight: '0.5rem' }} /> {t('job.clear')}
                            </Button>
                        </Grid2>

                    </Grid2>
                </form>
            </Box>
        </div>
    );
};

export default MissedExDateReport;
